import apiClient from './client';

// A disease-finding pair: {id, disease, finding, prevalence, knowledge, image_count}

export const getAssociation = (id) => apiClient.get(`/associations/${id}`).then((r) => r.data);

export const findAssociation = (diseaseId, findingId) =>
  apiClient
    .get('/associations', { params: { disease_id: diseaseId, finding_id: findingId } })
    .then((r) => r.data);

// Get or create: clicking an empty matrix cell
export const createAssociation = (diseaseId, findingId) =>
  apiClient
    .post('/associations', { disease_id: diseaseId, finding_id: findingId })
    .then((r) => r.data);
